import * as angular from "angular";
import * as _ from "lodash";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { LimitDataProvider } from "../../data-provider/limit.dp";
import { Campaign } from "../../models/campaign.model";
import { Limit } from "../../models/limit.model";
import { DialogUtils } from "../../helper/dialog.helper";

let ImportErrorDialogComponent = {
    selector: "vcImportErrorDialog",
    templateUrl: "/angular/components/voter-file/import-error.component.html",
    bindings: {},
    controller: class ImportErrorDialogController {
        private readonly dialog: DialogUtils;
        private readonly $window: any;
        private readonly __env: any;

        public activeCampaign: Campaign;
        public loading = true;
        public isLeaderView: boolean;
        public max: number;

        constructor(
            $window: any,
            __app_type: string,
            __env: any,
            DialogUtils: DialogUtils,
            CampaignDataProvider: CampaignDataProvider,
            LimitDataProvider: LimitDataProvider
        ) {
            this.dialog = DialogUtils;
            this.$window = $window;
            this.__env = __env;

            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
            this.isLeaderView = __app_type === "LEADER";

            LimitDataProvider.get().then((accountLimits: Limit) => {
                this.loading = false;
                this.max = accountLimits.houseoccupants;
            });
        }

        goToSettings(): void {
            this.$window.location = `./#/campaign/${this.activeCampaign.campaignid}`;
            this.dialog.cancel();
        }

        cancel(): void {
            this.dialog.cancel();
        }

        continue(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("voterFile")
    .component(ImportErrorDialogComponent.selector, ImportErrorDialogComponent);
